<template>
  <div class="footer">
    <div class="fnav">
      <div class="container">
        <router-link v-for="item in navs"
                     :key="item.id"
                     :to="item.href"
                     tag="a"
                     rel="nofollow">{{
          item.name
        }}</router-link>
      </div>
    </div>
    <div class="bottom">
      <div class="container">
        <div class="info">
          <p>Copyright 2012-2020 hkgene.cn 版权所有：华科鉴联基因科技（北京）有限公司 <a href="https://beian.miit.gov.cn/"
               target="_blank"
               rel="nofollow">京ICP备12051704号-6</a></p>
          <p>声明:本站部分信息图片来源于互联网,如果侵犯了您的权益敬请告知<a href="https://hkgene.cn/sitemap.xml"
               target="_blank"
               rel="nofollow">网站地图.sitemap</a></p>
        </div>
        <div class="right">
          <img src="/static/index/icon1.png"
               alt="" />
          <div class="phone">
            <p>15811205095</p>
            <span>固定电话：010-57281726&nbsp;客服在线时间：8:00-22:00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footers',
  data () {
    return {
      navs: [
        {
          id: 1,
          active: this.$route.name === this.$Router.index.name,
          name: '首页',
          href: this.$Router.index.path
        },
        {
          id: 2,
          active: this.$route.name === this.$Router.about.name,
          name: '关于我们',
          href: this.$Router.about.path
        },
        {
          id: 3,
          active: this.$route.name === this.$Router.services.name,
          name: '服务项目',
          href: this.$Router.services.path
        },
        {
          id: 4,
          active: this.$route.name === this.$Router.news.name,
          name: '新闻及案例分享',
          href: this.$Router.news.path
        },
        {
          id: 5,
          active: this.$route.name === this.$Router.training.name,
          name: '技术培训',
          href: this.$Router.training.path
        },
        {
          id: 6,
          active: this.$route.name === this.$Router.Partners.name,
          name: '合作伙伴',
          href: this.$Router.Partners.path
        },
        {
          id: 7,
          active: this.$route.name === this.$Router.database.name,
          name: '细胞系STR数据库在线比对',
          href: this.$Router.database.path
        },
        {
          id: 8,
          active: this.$route.name === this.$Router.literature.name,
          name: '细胞鉴定相关文献下载区',
          href: this.$Router.literature.path
        }
      ],
      footer: ``
    }
  }
}
</script>

<style lang="scss" scoped>
@import './footer.scss';
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue